export default import.meta.ROLLDOWN_FILE_URL_2Cr9jqnB7BE1yLJKm74XVA